import { Button } from '@/components/ui/button'
import { Link } from '@tanstack/react-router'

export function NotFound() {
  return (
    <>
      <div className={'flex flex-1 flex-col items-center justify-center'}>
        <h2 className={'text-center text-xl font-semibold'}>
          Страница не найдена
        </h2>
      </div>
      <Button asChild>
        <Link to={'/'}>Вернуться на главную</Link>
      </Button>
    </>
  )
}
